/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_Billing_PaymentMethodDto } from '../models/Routemize_DTOs_Billing_PaymentMethodDto';
import type { Routemize_DTOs_Billing_UpdatePaymentMethodDto } from '../models/Routemize_DTOs_Billing_UpdatePaymentMethodDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentMethodService {
    /**
     * @returns Routemize_DTOs_Billing_PaymentMethodDto OK
     * @throws ApiError
     */
    public static getApiAppPaymentMethodGetPaymentMethods(): CancelablePromise<Array<Routemize_DTOs_Billing_PaymentMethodDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/paymentMethod/getPaymentMethods',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Billing_PaymentMethodDto OK
     * @throws ApiError
     */
    public static putApiAppPaymentMethodUpdatePaymentMethod(
        requestBody?: Routemize_DTOs_Billing_UpdatePaymentMethodDto,
    ): CancelablePromise<Routemize_DTOs_Billing_PaymentMethodDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/paymentMethod/updatePaymentMethod',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param paymentMethodId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppPaymentMethodDeletePaymentMethod(
        paymentMethodId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/paymentMethod/deletePaymentMethod/{paymentMethodId}',
            path: {
                'paymentMethodId': paymentMethodId,
            },
        });
    }
}
